import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/network/clubSubscription',
            name: 'network_clubSubscription',
            component: () => import("./views/clubSubscription.vue"),
            meta: {
                bottomCutFixed: true,
            }
        },
        {
            path: '/network/clubSubscription/:identifier',
            name: 'network_clubSubscription_detail',
            component: () => import("./views/clubSubscriptionDetail.vue"),
            meta: {
                bottomCutFixed: true,
            }
        },
        {
            path: '/network/clubSubscription/:identifier/sign',
            name: 'network_clubSubscription_detail_sign',
            component: () => import("./views/clubSubscriptionDetailSign.vue"),
            meta: {
            }
        },
    ];
};